
class HelpModalController {
    constructor($rootScope, $uibModalInstance, $timeout, LoadedModel) {
        this._$rootScope = $rootScope;
        this._$uibModalInstance = $uibModalInstance;
        this._$timeout = $timeout;
        this.model = LoadedModel;
        this.timeout = $timeout(() => {
            this._$uibModalInstance.close();
            this.model.clearSession();
        }, 120000);
        this._$uibModalInstance.close();
    }

    ok() {
        this._$uibModalInstance.close();
        this._$rootScope.$broadcast('solverStarted', 'ping');
            this.model.sendPingRequest()
                .then(() => {
                    this.model.generateExpTime();
                    this._$timeout.cancel(this.timeout);
                }, () => {
                    this._$timeout.cancel(this.timeout);
                    this.model.generateExpTime();
                });
    }
}

HelpModalController.$inject = ['$rootScope', '$uibModalInstance', '$timeout', 'LoadedModel'];

export default HelpModalController;



// WEBPACK FOOTER //
// ./client/app/common/session-notification/session-notification-modal.controller.js